module.exports = __webpack_public_path__ + "img/25n.894dd3b6.png";